
// function that verifies if value contains only numbers
const countDecimals = (value, decimals) => {
    let string = "^-?\\d*(\\.\\d{0," + decimals + "})?$"
    let numberRex = new RegExp(string);
    //let numberRex = new RegExp("^-?\\d*(\\.\\d{0,2})?$");
    if (numberRex.test(value)) {
        return true;
    }
    return false;
}

const verifyLength = (value, length) => {
    if (value.length >= length) {
        return true;
    }
    return false;
}

// function that verifies if two strings are equal
const compare = (string1, string2) => {
    if (string1 === string2) {
        return true;
    }
    return false;
}

// function that verifies if value contains only numbers
export const verifyNumber = value => {
    //let numberRex = new RegExp("^[0-9]+$");
    let numberRex = new RegExp("^-?\\d*(\\.\\d+)?$");
    if (numberRex.test(value)) {
        return true;
    }
    return false;
}

// function that returns true if value is email, false otherwise
export const verifyEmail = value => {
    let emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
};

// const registerClick = component => {
//     if (component.state.registerEmailState === "") {
//         component.setState({ registerEmailState: "has-danger" });
//     }
//     if (
//         component.state.registerPasswordState === "" ||
//         component.state.registerConfirmPasswordState === ""
//     ) {
//         component.setState({ registerPasswordState: "has-danger" });
//         component.setState({ registerConfirmPasswordState: "has-danger" });
//     }
// }

// const loginClick = component => {
//     if (component.state.idsjobnumberState === "") {
//         component.setState({ idsjobnumberState: "has-danger" });
//     }
//     if (component.state.loginEmailState === "") {
//         component.setState({ loginEmailState: "has-danger" });
//     }
//     if (component.state.loginPasswordState === "") {
//         component.setState({ loginPasswordState: "has-danger" });
//     }
// }

// const typeClick = component => {
//     if (component.state.requiredState === "") {
//         component.setState({ requiredState: "has-danger" });
//     }
//     if (component.state.emailState === "") {
//         component.setState({ emailState: "has-danger" });
//     }
//     if (component.state.numberState === "") {
//         component.setState({ numberState: "has-danger" });
//     }
//     if (component.state.urlState === "") {
//         component.setState({ urlState: "has-danger" });
//     }
//     if (component.state.sourceState === "" || component.state.destinationState === "") {
//         component.setState({ sourceState: "has-danger" });
//         component.setState({ destinationState: "has-danger" });
//     }
// }

export function validateInput(event, component, stateName, type, stateNameEqualTo, maxValue, extraValue) {
    let statenameState = stateName + "State";
    let stateNameEqualToState = stateNameEqualTo + "State";
    switch (type) {
        case "email":
            if (verifyEmail(event.target.value)) {
                component.setState({ [statenameState]: "has-success" });
            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "equalTo":
            if (compare(event.target.value, stateNameEqualToState)) {
                component.setState({ [statenameState]: "has-success" });
                component.setState({ [statenameState]: "has-success" });
            } else {
                component.setState({ [statenameState]: "has-danger" });
                component.setState({ [stateNameEqualToState]: "has-danger" });
            }
            break;
        case "number":
            if (verifyNumber(event.target.value)) {
                component.setState({ [statenameState]: "has-success" });
            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "length":
            if (verifyLength(event.target.value, stateNameEqualTo)) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "max-length":
            if (!verifyLength(event.target.value, stateNameEqualTo + 1)) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "min-value":
            if (
                verifyNumber(event.target.value) &&
                event.target.value >= stateNameEqualTo
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "max-value":
            if (
                verifyNumber(event.target.value) &&
                event.target.value <= stateNameEqualTo
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "range":
            if (
                verifyNumber(event.target.value) &&
                event.target.value >= stateNameEqualTo &&
                event.target.value <= maxValue
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "decimal":
            if (
                countDecimals(event.target.value, maxValue) && //is number
                parseFloat(event.target.value) <= parseFloat(stateNameEqualTo)
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "decimalmin":
            if (
                countDecimals(event.target.value, maxValue) && //is number
                parseFloat(event.target.value) >= parseFloat(stateNameEqualTo)
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        case "decimalmaxmin":
            if (
                countDecimals(event.target.value, maxValue) && //is number

                parseFloat(event.target.value) > stateNameEqualTo &&
                event.target.value <= extraValue
            ) {
                component.setState({ [statenameState]: "has-success" });

            } else {
                component.setState({ [statenameState]: "has-danger" });
            }
            break;
        default:
            break;
    }
    component.setState({ [stateName]: event.target.value });
}

export function validateSubmit(stateItemsR, stateItemsN, component) {
    let isvalidated = true;

    // Validate non-nullable items
    for (const item of stateItemsR) {
        // Check if required items exist
        if (!component.state[item]) {
            component.setState({ [item + "State"]: "has-danger" });
            isvalidated = false;
            console.log("item doesn't exist:", item);
        }
        // Check if the inputs are valid
        else if (component.state[item + "State"] === "has-danger") {
            isvalidated = false;
            console.log("inputs are not valid:", item);
        }
    }

    // Validate nullable items
    for (const item of stateItemsN) {
        // Check if inputs are valid
        if (component.state[item] && component.state[item + "State"] === "has-danger") {
            isvalidated = false;
            console.log("nullable item not valid:", item);
        }
    }

    return isvalidated;
}

